import { DOCUMENTS_MUTATIONS, DOCUMENTS_QUERIES } from 'graphql/documents'
import type {
  DocumentsMutationsData,
  DocumentsMutationsName,
  DocumentsMutationsVariables,
  DocumentsQueriesData,
  DocumentsQueriesName,
  DocumentsQueriesVariables,
} from 'graphql/documents/types'
import { buildLazyQueryHook, buildMutationHook } from 'lib/apollo-client/builders'

export const useDocumentsLazyQueries = buildLazyQueryHook<
  DocumentsQueriesName,
  DocumentsQueriesVariables,
  DocumentsQueriesData
>(DOCUMENTS_QUERIES)

export const useDocumentsMutations = buildMutationHook<
  DocumentsMutationsName,
  DocumentsMutationsVariables,
  DocumentsMutationsData
>(DOCUMENTS_MUTATIONS)
